import EnhancedSEO from '@/components/seo/EnhancedSEO';
import { ProductSchema } from '@/components/seo/ProductSchema';
import { OG_IMAGES } from '@/constants/seoImages';
import PricingHero from '@/components/pricing/PricingHero';
import DualPathPlans from '@/components/pricing/DualPathPlans';
import FallbackLogicSection from '@/components/pricing/FallbackLogicSection';
import FeatureComparison from '@/components/pricing/FeatureComparison';
import PricingFAQ from '@/components/pricing/PricingFAQ';
import PricingCTA from '@/components/pricing/PricingCTA';
import ExpansionSection from '@/components/pricing/ExpansionSection';
import PartnerLogosSection from '@/components/shared/PartnerLogosSection';
import BillingClarificationBanner from '@/components/pricing/BillingClarificationBanner';
import { featureCategories } from '@/data/pricing/features';
import { freePlan } from '@/data/pricing/plans';
import { faqs } from '@/data/pricing/faqs';
import BreadcrumbListSchema from '@/components/seo/BreadcrumbListSchema';

const Pricing = () => {
  return (
    <>
      <EnhancedSEO 
        title="Pricing Plans - Your Home Operating System"
        description="Choose your plan: ThriveMax ($19/month) for independent living or ThriveFamily ($49/month) for family coordination. Request early access today — no credit card required."
        keywords="senior care pricing, ThriveMax pricing, ThriveFamily plan, home safety pricing, home operating system, early access"
        canonical="https://seniorthrive.com/pricing"
        image={OG_IMAGES.pricing}
        breadcrumbs={[
          { name: "Home", url: "https://seniorthrive.com/" },
          { name: "Pricing", url: "https://seniorthrive.com/pricing" }
        ]}
      />
      <BreadcrumbListSchema
        breadcrumbs={[
          { name: 'Home', url: 'https://seniorthrive.com/' },
          { name: 'Pricing', url: 'https://seniorthrive.com/pricing' },
        ]}
      />
      <ProductSchema
        name="SeniorThrive Platform"
        description="Comprehensive platform for senior safety, wellness tracking, and family coordination"
        price="19"
        currency="USD"
        brand="SeniorThrive"
        reviews={[
          { author: "Margaret Chen", rating: 5, reviewBody: "SeniorThrive gave me confidence to stay in my home safely." },
          { author: "Robert Johnson", rating: 5, reviewBody: "The safety scans caught hazards I never noticed." },
          { author: "Linda Martinez", rating: 5, reviewBody: "Keeping our family coordinated in dad's care has never been easier." }
        ]}
      />
      
      <div className="min-h-screen bg-gradient-to-br from-background via-muted/10 to-background">
        <PricingHero />

        <div className="container mx-auto px-4 pb-16">
          <DualPathPlans />

          <BillingClarificationBanner />

          <FallbackLogicSection />

          <FeatureComparison 
            featureCategories={featureCategories} 
            freePlan={freePlan} 
          />

          <ExpansionSection />

          <PartnerLogosSection
            title="Connected to Your World"
            description="SeniorThrive works alongside the services you already use to simplify daily logistics."
            className="my-16 border-y bg-muted/20"
          />

          <PricingFAQ faqs={faqs} />

          <PricingCTA />
        </div>
      </div>
    </>
  );
};

export default Pricing;
